import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { AppContextProvider } from '@contexts/AppContext';

import DeepResearchLayout from './Layout';
import DeepResearchPaywall from './Paywall';
import { DeepResearchProps } from './interfaces';

const queryClient = new QueryClient();

const DeepResearch = ({ env, initialCurrentUser, isWebview }: DeepResearchProps) => {
  const userCanAccess = initialCurrentUser?.is_pro_subscriber;

  return (
    <AppContextProvider env={env} initialCurrentUser={initialCurrentUser} isWebview={isWebview}>
      <QueryClientProvider client={queryClient}>
        {userCanAccess ? (
          <main className="mx-auto px-16 sm:px-28">
            <DeepResearchLayout />
          </main>
        ) : (
          <DeepResearchPaywall />
        )}
      </QueryClientProvider>
    </AppContextProvider>
  );
};

export default DeepResearch;
